<!-- The header's centred "News" link. On a news item's own page it's a breadcrumb,
     "News > 2026 > April 30": News and the year link to their pages; the date (the current
     page) is in brand green. News stays centred; the smaller crumbs extend to its right, clear of
     the logo on the left. From 860px only: below that they'd run into the right-hand menu, and
     the page's own heading has the same breadcrumb. -->

<template>
  <li :class="{selected: selected && !dayLabel}">
    <router-link to="/news">News</router-link>
    <span v-if="dayLabel" class="crumbs">
      <span class="separator">&gt;</span>
      <router-link :to="`/news/${route.params.year}`">{{ route.params.year }}</router-link>
      <span class="separator">&gt;</span>
      <span class="current" aria-current="page">{{ dayLabel }}</span>
    </span>
  </li>
</template>

<script setup>
import {computed} from "vue";
import {useRoute} from "vue-router";
import {getNewsMonthDay} from "@/composables/useNews";

defineProps({selected: {default: false}});
const route = useRoute();

// "April 30", or "April 30 (b)" for a second item that day; "" off a news item's page
const dayLabel = computed(() => {
  if (route.name !== "News Item") return "";
  const [, monthDay, letter] = route.params.day.match(/^(\d{2}-\d{2})(?:-([a-z]))?$/) || [];
  if (!monthDay) return "";
  const label = getNewsMonthDay(`${route.params.year}-${monthDay}`);
  return letter ? `${label} (${letter})` : label;
});
</script>

<style scoped>
li {
  list-style-type: none;
  display: flex;
  align-items: baseline;
  white-space: nowrap;
  letter-spacing: 0.03em;
}
a:hover {
  text-decoration: none;
}
li.selected :is(a, a:hover),
.current {
  color: var(--brand-color) !important; /* override colors from parent */
}
.separator,
.current {
  color: var(--primary-navigation-color);
  text-shadow: rgb(0, 0, 0) 0px 0px 6px;
  padding: 0.22rem 0;
}
.crumbs {
  width: 0; /* out of the centring: News stays where it is on every page; the crumbs overflow */
  display: flex;
  align-items: baseline;
  font-size: 1em; /* 1.5 × the other header links, as News itself (Menu.vue) */
}
@media (max-width: 859px) {
  .crumbs {
    display: none;
  }
}
.separator {
  margin: 0 0.15em;
}
</style>
